var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: { "label-width": "70px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: { placeholder: "请输入模板名称", disabled: "" },
                    model: {
                      value: _vm.detail.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.detail, "name", $$v)
                      },
                      expression: "detail.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否包邮" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { disabled: "" },
                      on: { change: _vm.select },
                      model: {
                        value: _vm.arr,
                        callback: function ($$v) {
                          _vm.arr = $$v
                        },
                        expression: "arr",
                      },
                    },
                    _vm._l(_vm.types, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运送方式" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.checked1,
                        callback: function ($$v) {
                          _vm.checked1 = $$v
                        },
                        expression: "checked1",
                      },
                    },
                    [
                      _vm._v(
                        " 快递（除指定地区外，其余地区的运费采用“默认运费”）"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮费设置" } },
                [
                  _c("div", { staticStyle: { "margin-top": "14px" } }),
                  _vm.detail.calculType == 1
                    ? _c("number", {
                        style: {
                          marginBottom:
                            _vm.tableDataF.length == 0 ? "20px" : "",
                        },
                        attrs: {
                          isEdit: false,
                          tableData: _vm.tableData,
                          freight: _vm.detail.freight,
                          baseNumber: _vm.detail.baseNumber,
                          addNum: _vm.detail.addNum,
                          addPrice: _vm.detail.addPrice,
                        },
                      })
                    : _vm._e(),
                  _vm.detail.calculType == 2
                    ? _c("weight", {
                        attrs: {
                          isEdit: false,
                          tableData: _vm.tableData,
                          freight: _vm.detail.freight,
                          baseNumber: _vm.detail.baseNumber,
                          addNum: _vm.detail.addNum,
                          addPrice: _vm.detail.addPrice,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.tableDataF.length != 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("free-delivery", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: { tableData: _vm.tableDataF, isEdit: false },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "back-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }